import { render, staticRenderFns } from "./ModelLabel.vue?vue&type=template&id=52006eb9&scoped=true"
import script from "./ModelLabel.vue?vue&type=script&lang=js"
export * from "./ModelLabel.vue?vue&type=script&lang=js"
import style0 from "./ModelLabel.vue?vue&type=style&index=0&id=52006eb9&prod&lang=css"
import style1 from "./ModelLabel.vue?vue&type=style&index=1&id=52006eb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52006eb9",
  null
  
)

export default component.exports